import { useState } from "react";
import Event from "./Event";
import { useTranslation } from 'react-i18next';
export default function Events(props) {
  const { data } = props;
  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => {
    setShowAll(!showAll);
    
  };
  const { t } = useTranslation();
    const RECENT_EVENTS=t("RECENT_EVENTS");
    const VIEW_MORE=t("VIEW_MORE");
    const VIEW_LESS=t("VIEW_LESS");
    const INVALID_DATE=t("INVALID_DATE");
    const LOADING=t("LOADING")
  const displayedData = showAll ? data : data.slice(0, 6); // Initially show first 3 cards
  return (t,
    <main id="events" className="main-page">
      <section className="page-section q-pa-md">
        <div className="container-fluid">
          <div className="grid">
            <div className="col comp-grid">
              <h5>{RECENT_EVENTS}</h5>
            </div>
          </div>
          <div className="w-full h-full flex gap-3 flex-wrap">
            {displayedData?.map((event) => {
              const {
                key,
                action_name,
                event_time,
                module_name,
                imageSrc,
                bgColor,
                mrn,
              } = event;
              const date = new Date(event_time);
              const month = date.toLocaleString("default", { month: "long" });
              const day = String(date.getDate()).padStart(2, "0");
              const time = date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });
              return (
                <Event
                  key={key}
                  title={action_name}
                  imageSrc={imageSrc}
                  bgColor={bgColor}
                  month={month}
                  day={day}
                  time={time}
                  module_name={module_name}
                  mrn={mrn}
                />
              );
            })}
            <a
              href="#"
              style={{
                color: "var(--primary-color)",
              }}
              onClick={toggleShowAll}
            >
              {showAll ? VIEW_LESS : VIEW_MORE}
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
